import { TFunction } from 'i18next';

import { ICampaign, IVolumeDistribution } from '@/modules/study-insights/services/campaign';
import { AddCampaignFormStringValues, AddCampaignValidationFields } from '../AddCampaignForm/AddCampaignForm.types';
import { addCampaignValidationConfig } from '../AddCampaignForm/AddCampaignForm.helper';

export const validateFormFn = ({ t }: { t: TFunction }): AddCampaignValidationFields => {
  const addValidateRequirements = addCampaignValidationConfig({ t });
  return {
    ...addValidateRequirements,
    campaignName: {
      shouldValidate: false,
    },
    campaignSource: {
      shouldValidate: false,
    },
    campaignMedium: {
      shouldValidate: false,
    },
    campaignID: {
      shouldValidate: true,
      validateFn: (newValue: string) => newValue.length > 1,
      validationError: t('add_campaign.campaign_id.error'),
    },
  };
};

export const transformICampaignToAddCampaignFormStringValues = (values: ICampaign): AddCampaignFormStringValues => {
  return Object.entries(values).reduce<AddCampaignFormStringValues>((acc, [key, value]) => {
    if (key === 'volumeDistribution' && !!value) {
      const volume = value.map((mapValue: IVolumeDistribution) => {
        return {
          numberOfEnrollees: mapValue.numberOfEnrollees.toString(),
          distributionDate: mapValue.distributionDate.toString(),
        };
      });
      acc.volumeDistribution = volume;
    } else if (value) {
      acc[key as keyof ICampaign] = value.toString();
    }
    return acc;
  }, {});
};
